import { Menu, MenuItem, ListItemIcon, ListItemText } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import DeleteIcon from "@mui/icons-material/Delete";
import { useState } from "react";
import { Link } from "react-router-dom";

interface DetailedListingActionMenuProps {
  row: any;
  handleDelete?: (id: string) => void;
  handleDownloadPDF?: (id: string) => void;
  handleDownloadPDF2?: (id: string) => void;
  handleViewModal?: (id: string) => void;
  canChange: boolean;
  canDelete?: boolean;
}

export const DetailedListingActionMenu = ({
  row,
  handleDelete,
  handleDownloadPDF,
  handleDownloadPDF2,
  handleViewModal,
  canChange,
  canDelete = false,
}: DetailedListingActionMenuProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <button
        onClick={handleClick}
        style={{
          background: "none",
          border: "none",
          padding: 0,
          cursor: "pointer",
        }}
      >
        <i className="bi bi-three-dots-vertical fs-5 text-dark"></i>
      </button>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{ 
          elevation: 0,
          sx: { 
            fontFamily: 'var(--bs-font-sans-serif) !important',
            minWidth: '160px',
            zIndex: '9999',
            backgroundColor: 'transparent',
            '& *': {
              fontFamily: 'var(--bs-font-sans-serif) !important'
            },
            '& .MuiMenuItem-root': {
              minHeight: '32px',
              padding: '8px 16px',
              border: '1px solid #e0e0e0',
              borderBottom: '1px solid #e0e0e0',
              backgroundColor: 'white',
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
              '&:first-child': {
                borderTopLeftRadius: '8px',
                borderTopRightRadius: '8px'
              },
              '&:last-child': {
                borderBottomLeftRadius: '8px',
                borderBottomRightRadius: '8px',
                borderBottom: '1px solid #e0e0e0'
              },
              '&:hover': {
                backgroundColor: '#f8f9fa'
              }
            },
            '& .MuiMenuItem-root .MuiListItemText-primary': {
              fontSize: '13px !important',
              fontWeight: '500 !important'
            }
          }
        }}
      >
        {canChange && (
          <MenuItem
            component={Link}
            to={`/edit-quotation/${row.original.quotation_id}`}
            onClick={handleClose}
          >
            <ListItemIcon>
              <EditIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Edit" />
          </MenuItem>
        )}

        <MenuItem
          onClick={() => {
            if (handleViewModal) {
              handleViewModal(row.original.quotation_id);
            } else {
              // Fallback to navigation if no modal handler provided
              window.location.href = `/view-quotation/${row.original.quotation_id}`;
            }
            handleClose();
          }}
        >
          <ListItemIcon>
            <VisibilityIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="View" />
        </MenuItem>

        <MenuItem
          onClick={() => {
            if (handleDownloadPDF) handleDownloadPDF(row.original.quotation_id);
            handleClose();
          }}
        >
          <ListItemIcon>
            <PictureAsPdfIcon fontSize="small" color="info" />
          </ListItemIcon>
          <ListItemText primary="Download PDF 1" />
        </MenuItem>

        <MenuItem
          onClick={() => {
            if (handleDownloadPDF2)
              handleDownloadPDF2(row.original.quotation_id);
            handleClose();
          }}
        >
          <ListItemIcon>
            <PictureAsPdfIcon fontSize="small" color="info"/>
          </ListItemIcon>
          <ListItemText primary="Download PDF 2" />
        </MenuItem>
        
        {canDelete && (
          <MenuItem
            onClick={() => {
              if (handleDelete) handleDelete(row.original.quotation_id);
              handleClose();
            }}
            sx={{ color: "error.main" }}
          >
            <ListItemIcon>
              <DeleteIcon fontSize="small" color="error" />
            </ListItemIcon>
            <ListItemText primary="Delete" />
          </MenuItem>
        )}
      </Menu>
    </>
  );
};
